import { CheckCircle, XCircle } from "lucide-react";

interface SignalReasonPanelProps {
  text: string;
  passed: boolean;
}

const SignalReasonPanel = ({ text, passed }: SignalReasonPanelProps) => {
  const ReasonIcon = passed ? CheckCircle : XCircle;

  return (
    <div className="rounded-lg bg-gray-50 px-4 py-3">
      <div className="mb-2 flex items-center gap-2">
        <ReasonIcon className="h-4 w-4 shrink-0 text-gray-500" />
        <p className="text-sm font-semibold text-gray-900">Reason</p>
      </div>
      <p className="text-sm leading-5 text-gray-700">{text}</p>
    </div>
  );
};

export default SignalReasonPanel;
